import { useEffect } from "react";
import { createRouter, useRouter, type ErrorComponentProps } from "@tanstack/react-router";
import { routeTree } from "./routeTree.gen";
import { FullPageLoader } from "@/components/ui/loader";

function DefaultErrorComponent({ error, reset }: ErrorComponentProps) {
  const router = useRouter();

  // Auto-retry instead of showing an error screen.
  useEffect(() => {
    if (typeof window !== "undefined" && import.meta.env.DEV) {
      // eslint-disable-next-line no-console
      console.error(error);
    }
    const t = setTimeout(() => {
      try {
        router.invalidate();
        reset?.();
      } catch {
        if (typeof window !== "undefined") window.location.reload();
      }
    }, 2500);
    return () => clearTimeout(t);
  }, [error, reset, router]);

  return <FullPageLoader />;
}

export const getRouter = () => {
  const router = createRouter({
    routeTree,
    context: {},
    scrollRestoration: true,
    defaultPreloadStaleTime: 0,
    defaultErrorComponent: DefaultErrorComponent,
  });

  return router;
};
